import React from 'react';
import { ConnectDocuments } from '@stripe/react-connect-js';
import { PageHeader } from '../../../components/ui';
import COPY from '../../connect/finance/connect-finance-copy';
import { useFinanceSection } from '../section/finance-section-context';
import FinancePageShell from './finance-page-shell';

// Stripe issues these, so there is nothing to show until Stripe has an
// account to issue them for. Moved here from Settings -> Payments (spec
// 2026-09-14 §1), where account-sections.js carried this same content as its
// "Documents" tab; the copy for each state below is unchanged from there.
const TaxDocuments = () => {
  const { status, instance, sessionFailure } = useFinanceSection();
  const hasAccount = !!status?.hasAccount;
  // Precedence, the same one account-sections.js settled on: a session that
  // failed wins over an `instance` that merely exists.
  const sessionOk = !!instance && !sessionFailure;

  // Not the raw server refusal for a company with no Stripe account — that
  // is a fact about our own API, not something this page should ever echo
  // verbatim under a "Documents" heading. Say it in the page's own voice
  // instead, and check `hasAccount` first: a session failing for an
  // entirely different reason on an account that does exist still gets its
  // own real failure line below.
  const body = !hasAccount ? (
    <p className="text-[13.5px] text-fin-muted">
      Your tax documents will appear here once Stripe has this account set up.
    </p>
  ) : sessionOk ? (
    <ConnectDocuments />
  ) : (
    <p className="text-[13.5px] text-fin-muted">
      {COPY.restaurant.sessionFailed}
    </p>
  );

  return (
    <FinancePageShell column="reading">
      <PageHeader
        title="Tax Documents"
        description="1099-K and every other tax form Stripe issues for this account."
      />
      {/* The same thin-bordered card Payouts, Business Details and Order
          Reports draw (owner, 2026-09-23); the Finance tokens carry dark
          mode. */}
      <section className="overflow-hidden rounded-xl border border-fin-border bg-fin-surface">
        <div className="p-5">{body}</div>
      </section>
    </FinancePageShell>
  );
};

export default TaxDocuments;
